export default __webpack_public_path__ + "static/2266-7fe876f41bfc869ab07f17e9130c1d23.gif";